import React from 'react';
export function CTABanner() {
  return <section className="bg-prt-blue py-20 relative overflow-hidden" data-id="element-86">
      {/* Subtle mesh pattern overlay */}
      <div className="absolute inset-0 opacity-10 mix-blend-multiply" style={{
      backgroundImage: 'radial-gradient(#000 2px, transparent 2px)',
      backgroundSize: '16px 16px'
    }} data-id="element-87" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-88">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10" data-id="element-89">
          <div className="text-center lg:text-left" data-id="element-90">
            <h2 className="font-heading text-prt-darker text-5xl md:text-6xl mb-4" data-id="element-91">
              READY TO START?
            </h2>
            <p className="text-prt-darker/80 text-xl font-medium max-w-xl" data-id="element-92">
              Join the PRT community and start realizing your potential today.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto" data-id="element-93">
            <button className="bg-prt-darker hover:bg-black text-white px-8 py-4 rounded font-heading tracking-wider text-xl transition-colors min-h-[48px] w-full sm:w-auto" data-id="element-94">
              View Class Schedule
            </button>
            <button className="border-2 border-prt-darker hover:bg-prt-darker hover:text-white text-prt-darker px-8 py-4 rounded font-heading tracking-wider text-xl transition-colors min-h-[48px] w-full sm:w-auto" data-id="element-95">
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>;
}